import React, { useState } from 'react';
import { format, isToday } from 'date-fns';
import { CoachAvailabilityStatusesEnum } from 'types/generated/client';
import { RemoteCoachTypesEnum } from 'utils/shared/coach/constants';
import { formatUrl } from 'utils/shared/formatUrl';
import CourtFlat from 'svg/CourtFlat';
import { PickDateProps } from 'screens/PlayerLoggedInScreen/props';
import Button from 'components/Button';
import DatePicker from 'components/DatePicker';
import Pill from 'components/Pill';

const PickDate: React.FC<PickDateProps> = ({ onNext, coach }) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const handleContinue = () => {
    if (selectedDate) {
      onNext(selectedDate);
    }
  };

  const checkCoachAvailability = (day: Date) => {
    if (!coach || !coach.coachAvailability) {
      return true;
    }

    const dayOfWeek = format(day, 'EEEE').toUpperCase();
    const coachAvailability = coach.coachAvailability;

    return (
      coachAvailability.some(
        (slot) =>
          slot.status === CoachAvailabilityStatusesEnum.Active && slot.dayOfWeek === dayOfWeek,
      ) || isToday(day)
    );
  };

  const handleDayClick = (day: Date) => {
    if (coach?.coachExternalBookingUrl) {
      window.open(formatUrl(coach.coachExternalBookingUrl), '_blank');
    } else {
      setSelectedDate(day);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="flex items-start p-ds-xl max-sm:flex-col max-sm:items-center max-sm:justify-center max-sm:gap-8 max-sm:p-ds-lg">
        <Pill
          className={'absolute bg-color-remote-bg !text-color-remote-text max-sm:relative'}
          icon={<CourtFlat className="h-4 w-4" />}
          text={'On-Court'}
          size="sm"
        />
        <DatePicker
          selectedDate={selectedDate}
          onDateChange={setSelectedDate}
          minDate={today}
          isDaySelectable={checkCoachAvailability}
          onDayClick={handleDayClick}
          className="mx-auto max-w-[17.5rem]"
        />
      </div>

      <div className="flex justify-end border-color-border-input-lightmode px-ds-xl py-5 dark:border-color-border-input-darkmode max-sm:px-ds-lg sm:border-t">
        <Button variant="brand" size="lg" onClick={handleContinue} className="sm:w-fit">
          Select
        </Button>
      </div>
    </div>
  );
};

export default PickDate;
